export default {
    /**
     * данные
     * @property {number} windowWidth - ширина экрана
     */
    data: () => ({
        windowWidth: window.innerWidth,
    }),
    computed: {
        /**
         * условие маленького окна
         * @returns {boolean}
         */
        isSmallWindow() {
            return this.windowWidth <= 768;
        }
    },
    created() {
        // слушаем изменение размеров экрана
        window.addEventListener('resize', this.updateWindowWidth);
    },
    destroyed() {
        // отписываемся от прослушивания изменения экрана
        window.removeEventListener('resize', this.updateWindowWidth)
    },
    methods: {
        /**
         * обновить ширину окна
         */
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        }
    }
};